import { shortenNumber } from '@ydistri/generic-utils';
import { StatisticItem } from '../StatisticsSummary';
import { SkuRedistributionResponse } from '@ydistri/api-sdk';

export const buildPickingPositionsStats = (
  pickingPositions: SkuRedistributionResponse[] | undefined | null,
  currency: string,
): StatisticItem[] => {
  const totalValue = pickingPositions?.reduce((sum, r) => sum + r.value, 0) ?? 0;
  const totalQuantity = pickingPositions?.reduce((sum, r) => sum + r.quantity, 0) ?? 0;
  const totalPickingPositions = pickingPositions?.length ?? 0;

  const distinctSourceStoreCount = pickingPositions
    ? new Set(pickingPositions.map(r => r.sourceStore.id)).size
    : 0;

  const distinctTargetStoreCount = pickingPositions
    ? new Set(pickingPositions.map(r => r.targetStore.id)).size
    : 0;

  const distinctProductCount = pickingPositions
    ? new Set(pickingPositions.map(r => r.product.id)).size
    : 0;

  const valueStat = { title: `Value (${currency})`, value: shortenNumber(totalValue) };
  const quantityStat = { title: 'Quantity', value: shortenNumber(totalQuantity) };

  if (pickingPositions?.length === 1) {
    return [valueStat, quantityStat];
  }

  return [
    { title: 'Distinct Source Stores', value: distinctSourceStoreCount },
    { title: 'Distinct Target Stores', value: distinctTargetStoreCount },
    { title: 'Distinct Products', value: distinctProductCount },
    { title: 'Picking Positions', value: shortenNumber(totalPickingPositions) },
    valueStat,
    quantityStat,
  ];
};
